module.exports = __webpack_public_path__ + "afc6d045.jpg";